export type CsvData = {
  columns: string[];
  rows: string[][];
};

// A null `column` searches every cell; a named column scopes to it. An unknown
// column name matches nothing to filter on, so all rows pass through.
export function filterCsvRows(
  data: CsvData,
  search: string,
  column: string | null
): string[][] {
  const query = search.trim().toLowerCase();
  if (!query) return data.rows;
  if (column) {
    const index = data.columns.indexOf(column);
    if (index < 0) return data.rows;
    return data.rows.filter((row) =>
      (row[index] ?? "").toLowerCase().includes(query)
    );
  }
  return data.rows.filter((row) =>
    row.some((cell) => cell.toLowerCase().includes(query))
  );
}

export type Page<T> = {
  rows: T[];
  offset: number;
  hasPrevious: boolean;
  hasNext: boolean;
};

export function paginate<T>(
  rows: T[],
  page: number,
  pageSize: number
): Page<T> {
  const offset = page * pageSize;
  const pageRows = rows.slice(offset, offset + pageSize);
  return {
    rows: pageRows,
    offset,
    hasPrevious: page > 0,
    hasNext: offset + pageRows.length < rows.length,
  };
}
